export default "__VITE_ASSET__43c0af83__"